import { IPMChart } from '@/ship/Models/IProjectManagement';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import { getProjectManagementCharts } from '@/utils/api/ProjectManagement/ProjectManagement';
import ErrorService from '@/utils/ErrorService';
import { ref } from 'vue';

export function useCharts() {
    const charts = ref<IPMChart[]>([]);

    const fetchCharts = async (params?: GetRequestParams) => {
        try {
            const {
                data: { data: _charts },
            } = await getProjectManagementCharts(params);

            charts.value = _charts;
        } catch (err) {
            ErrorService.handleApiError(err);
        }
    };

    const findChartById = (_id: number) => {
        return charts.value.find(({ id }) => id === _id);
    };

    return {
        fetchCharts,
        charts,
        findChartById,
    };
}
